import { mockEmployeesDetails } from './mockEmployees';

export const mockEmployeeDetailGetRes = Object.values(mockEmployeesDetails).reduce(
  (acc, backendData) => ({ ...acc, [backendData.employee.employeeId]: backendData }),
  {}
);

export default mockEmployeeDetailGetRes;
